import { Store, StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import TikTokGalleryEntity from "../entities/TikTokGalleryEntity";

export interface TikTokGalleryState {
    gallery: TikTokGalleryEntity | null;
}

export function createInitialState(): TikTokGalleryState {
    return {
        gallery: null,
    };
}

@singleton()
@StoreConfig({ name: "tiktok-galleries" })
class TikTokGalleryStore extends Store<TikTokGalleryState> {
    constructor() {
        super(createInitialState());
    }
}

export default TikTokGalleryStore;
